import {
  HYBRID_APP_MODE_STORAGE_KEY,
  PROFILE_SCOPE_OWNER_USER_ID_KEY,
  PROFILE_SCOPE_STORAGE_KEY,
} from "../../constants";
import { AuthorizationSet } from "../../dto";
import {
  localStorageHelpers,
  sessionFirstStorageHelpers,
} from "./storage.helpers";

export class ProfileStorage {
  static get authSet(): AuthorizationSet | undefined {
    return (
      sessionFirstStorageHelpers.getItem<AuthorizationSet>(
        PROFILE_SCOPE_STORAGE_KEY,
      ) || undefined
    );
  }

  static set authSet(value) {
    if (!value) {
      sessionFirstStorageHelpers.removeItem(PROFILE_SCOPE_STORAGE_KEY);
    } else {
      sessionFirstStorageHelpers.setItem(PROFILE_SCOPE_STORAGE_KEY, value);
    }
  }

  static get authSetOwnerUserId(): number | undefined {
    const value = sessionFirstStorageHelpers.getItem<number>(
      PROFILE_SCOPE_OWNER_USER_ID_KEY,
    );

    return value ?? undefined;
  }

  static set authSetOwnerUserId(value: number | undefined) {
    if (value === undefined) {
      sessionFirstStorageHelpers.removeItem(PROFILE_SCOPE_OWNER_USER_ID_KEY);
    } else {
      sessionFirstStorageHelpers.setItem(
        PROFILE_SCOPE_OWNER_USER_ID_KEY,
        value,
      );
    }
  }

  static clearScope(): void {
    ProfileStorage.authSet = undefined;
  }

  static prepareScopeForUserLogin(userId: number): void {
    const previousOwnerUserId = ProfileStorage.authSetOwnerUserId;

    if (previousOwnerUserId !== undefined && previousOwnerUserId !== userId) {
      ProfileStorage.clearScope();
    }

    ProfileStorage.authSetOwnerUserId = userId;
  }

  static get isHybridMode(): boolean {
    return localStorageHelpers.getItem(HYBRID_APP_MODE_STORAGE_KEY) ?? false;
  }

  static set isHybridMode(value) {
    if (!value) {
      localStorageHelpers.removeItem(HYBRID_APP_MODE_STORAGE_KEY);
    } else {
      localStorageHelpers.setItem(HYBRID_APP_MODE_STORAGE_KEY, value);
    }
  }
}
